import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export type PublishAiStepState = 'generating' | 'insert' | 'complete';

export interface PublishAiStep {
    title?: string;
    state: any;         // ko.observable<PublishAiStepState>
    btnText?: string;
    insertClick: () => void;
}

/**
 * KO template that renders an ordered list of prerequisite steps for the AI publish flow.
 * Each step has a reactive state observable ('generating' | 'insert' | 'complete') that
 * drives which UI element is shown in the action slot.
 *
 * Usage:
 *   const tpl = new publishAIActions_template(uniqueId, koHolder, caller);
 *   new AnchorPopup(anchor, { contentTemplate: tpl, ... });
 *   tpl.setStepState(0, 'insert', cb, 'button text',  'step title goes here');   // update later
 */
export class publishAIActions_template extends vnTemplate {

    private insertCallbacks: { [index: number]: () => void } = {};
    protected stepTooltip: infoButton_template;

    protected buildViewModel(): any {
        return {
            steps: ko.observableArray(this.buildSteps()),
        };
    }

    protected buildSteps(): PublishAiStep[] {
        return [
            {
                title: ko.observable(''),
                state: ko.observable('generating' as PublishAiStepState),
                insertClick: () => this.triggerInsertClick(0),
                btnText: ko.observable('Insert Suggestion'),
            },
        ];
    }

    protected initPartial(): void {
        this.stepTooltip = new infoButton_template('stepTooltip', this.getTemplateViewModel(), this.caller);
        this.stepTooltip.setTitle('Insert Widget');
        this.stepTooltip.setContent('<p>Initial widget placement is targeted at 66% content depth between two paragraphs. If no natural paragraph break exists at that point, the system defers downward to the first available opportunity.</p>');
    }

    private triggerInsertClick(index: number): void {
        const cb = this.insertCallbacks[index];
        if (cb) cb();
    }

    /**
     * Update the state of a step.
     * @param index        Zero-based step index.
     * @param state        New state to display.
     * @param insertClick  Required when state === 'insert'. Called when the Insert button is clicked.
     */
    public setStepState(index: number, state: PublishAiStepState, insertClick?: () => void, btnText?: string, title?: string): void {
        const steps = this.getTemplateViewModel().steps();
        if (!steps[index]) return;
        steps[index].state(state);
        if (title) {
            steps[index].title(title);
        }
        if (btnText) {
            steps[index].btnText(btnText);
        }
        if (insertClick !== undefined) {
            this.insertCallbacks[index] = insertClick;
        }
        this.getTemplateViewModel().steps.valueHasMutated();
    }

    protected getTemplateName(): string {
        return 'publishAIActions_template';
    }

    protected getTemplateHtml(): string {
        return /* html */`
            <div class="publish-ai-actions__container">
                <strong class="icon i-status-requires-review">Before saving...</strong>

                <ol data-bind="foreach: steps" class="publish-ai-actions__list">

                    <li>
                        <strong>Assess Opportunity for Widgets</strong>
                        <span>
                            <span class="title" data-bind="text: title"></span>
                            <span class="publish-ai-actions__status">
                                <!-- ko if: state() === 'generating' -->
                                <span class="anchor-popup__spinner"></span> Generating Suggestion
                                 <!-- /ko -->
                                <!-- ko if: state() === 'insert' -->
                                <button type="button" data-bind="click: insertClick"><span class="insert icon i-ins"></span> <span>Insert Where Suggested</span></button>
                                <!-- /ko -->
                                <!-- ko if: state() === 'complete' -->
                                <span class="complete icon i-check"></span> Suggestion Generated
                                <!-- /ko -->
                            </span>
                             <!-- ko if: state() === 'insert' -->
                            <div class="w-tooltips-adv pos-right short">
                                <div class="infoButton" data-bind="template: { name: 'infoButton-template', data: $parent.stepTooltip }"></div>
                            </div>
                             <!-- /ko -->
                        </span>
                    </li>

                </ol>

            </div>
        `;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/publishAIActions_template.ts